import {IressOrderRecord, IressOrderRecords} from "../../../models/iress/IressOrderRecord";
import {isSameOrder, placedBrokerOrder, PlacedBrokerOrders} from "../../placed/models/PlacedOrder";
import {ArrayUtil} from "../../../../js/util/ArrayUtil";
import {flatMap} from "../../../../js/util/UtilFunctions";
import {OrderDestinationService} from "../../../services/OrderDestinationService";
import {OrderDestination} from "app/orders/models/OrderRecord";

export function orderIsMine(order: IressOrderRecord, placedOrders: PlacedBrokerOrders): boolean {

    const walk = (root: IressOrderRecord): boolean => {
        if (isMine(root, placedOrders)) { // If this order is the one we're looking for, all good
            return true;
        } else if (root.childOrders.length === 0) { // If no children then it isn't the one we're looking for
            return false;
        } else { // Otherwise check if any children match
            for (const child of root.childOrders) {
                if (walk(child)) {
                    return true;
                }
            }
            return false;
        }
    };

    return walk(order);
}

function isMine(order: IressOrderRecord, placedOrders: PlacedBrokerOrders): boolean {
    const placed = placedBrokerOrder(order.orderNumber);
    return ArrayUtil.includes(placedOrders, placed, isSameOrder);
}

export function findChildDestinationOrders(order: IressOrderRecord): IressOrderRecords {
    const destinations = OrderDestinationService.orderDestinations(order.iosServer);

    const walk = (destination: OrderDestination, root: IressOrderRecord): IressOrderRecords => {
        if (root.destination === destination) {
            return [root];
        } else if (root.childOrders.length === 0) {
            return [];
        } else {
            return root.childOrders
                       .map((o) => walk(destination, o))
                       .reduce(flatMap, []);
        }
    };

    for (const dest of destinations) {
        const result = walk(dest, order);
        if (result.length > 0) {
            return result;
        }
    }
    return [];
}
